import React from 'react';
import { SvgIcon, SvgIconProps } from '../components/svgIcon';

export const CalendarIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <SvgIcon cacheName="calendar" ref={ref as any} {...props}>
      <path
        clipRule="evenodd"
        d="M18 5.05762H6C5.44772 5.05762 5 5.50533 5 6.05762V18.0576C5 18.6099 5.44772 19.0576 6 19.0576H18C18.5523 19.0576 19 18.6099 19 18.0576V6.05762C19 5.50533 18.5523 5.05762 18 5.05762ZM6 4.05762C4.89543 4.05762 4 4.95305 4 6.05762V18.0576C4 19.1622 4.89543 20.0576 6 20.0576H18C19.1046 20.0576 20 19.1622 20 18.0576V6.05762C20 4.95305 19.1046 4.05762 18 4.05762H6Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M18 5.05762H6C5.44772 5.05762 5 5.50533 5 6.05762V9.21146H19V6.05762C19 5.50533 18.5523 5.05762 18 5.05762ZM6 4.05762C4.89543 4.05762 4 4.95305 4 6.05762V10.2115H20V6.05762C20 4.95305 19.1046 4.05762 18 4.05762H6Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M10 2.5C10.2761 2.5 10.5 2.72386 10.5 3V6C10.5 6.27614 10.2761 6.5 10 6.5C9.72386 6.5 9.5 6.27614 9.5 6V3C9.5 2.72386 9.72386 2.5 10 2.5Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M14 2.5C14.2761 2.5 14.5 2.72386 14.5 3V6C14.5 6.27614 14.2761 6.5 14 6.5C13.7239 6.5 13.5 6.27614 13.5 6V3C13.5 2.72386 13.7239 2.5 14 2.5Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </SvgIcon>
  );
});
